import React from 'react';
import { ModelDefinitionDto } from '../../models/APIModels';
import { Box, Button, Card, Chip, Popover, Rating, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
import MuiButton from '@mui/material/Button';

interface Iprops {
  model: ModelDefinitionDto;
  logoUrl: string;
  openExternalLink: () => void;
  openReviewModal: (value) => void;
  headerAction: (text) => void;
  goToSearch: (param) => void;
}



const HeaderSection = ({ model, logoUrl, openExternalLink, openReviewModal, headerAction, goToSearch }: Iprops) => {


  
  const navigate = useNavigate();
  const [anchorTagEl, setAnchorTagEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorTagEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorTagEl(null);
  };
  const open = Boolean(anchorTagEl);
  const id = open ? 'tags-details-popover' : undefined;

  return (
    <div className="content-with-sidebars">
      <div className="left-section">
        <Card className="model-logo-container">
          <img className="model-logo" onClick={openExternalLink} src={logoUrl} loading="lazy" />
        </Card>
      </div>
      <div className="content-section">
        <div className="header-section">
          <h1 style={{ marginBottom: '0px', marginTop: '1px', fontWeight: '600' }}>
            <span className="nav-link" onClick={openExternalLink}>
              {model.modelName}
            </span>
          </h1>
          <Typography sx={{ display: 'flex' }}>
            By
            <span>
              <a className="nav-link active" onClick={() => navigate(`/profile/${model.author}`)}>
                {model.author}
              </a>
            </span>
          </Typography>
        </div>
        {open && (
          <Popover
            id={id}
            open={open}
            anchorEl={anchorTagEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            {model.tags.map((t, index) => {
              return (
                <Box sx={{ margin: '5px' }}>
                  <Chip
                    label={t.displayName}
                    color="info"
                    size="small"
                    sx={{ marginRight: '3px', fontSize: '12px', marginBottom: '3px' }}
                  ></Chip>
                </Box>
              );
            })}
          </Popover>
        )}
        <div className="content-details">
          <div style={{ display: 'flex' }}>
            <Typography>
              <VisibilityIcon />
            </Typography>
            <div style={{paddingLeft:'5px', paddingTop:'1px'}}>{model.totalViews}</div>
          </div>
          {model.modelCategory && (
            <Typography sx={{ fontSize: 14, display: 'flex' }} color="text.secondary" gutterBottom>
              Category:{' '}
              <a className="nav-link active" onClick={() => goToSearch({ category: model.modelCategory })}>
                {model.modelCategory}
              </a>
            </Typography>
          )}
          {model.tags.length > 0 && (
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
              {model.tags.map((t, index) => {
                return (
                  <>
                    {index < 2 && (
                      <Chip
                        label={t.displayName}
                        color="info"
                        size="small"
                        sx={{ marginRight: '3px', fontSize: '12px', marginBottom: '3px' }}
                      ></Chip>
                    )}
                  </>
                );
              })}
              {model.tags.length > 2 && (
                <Chip
                  label={`+ ${model.tags.length - 2}`}
                  color="info"
                  size="small"
                  title="Show More"
                  sx={{ marginRight: '3px', fontSize: '12px', cursor: 'pointer', marginBottom: '3px' }}
                  onClick={(e) => handleClick(e)}
                ></Chip>
              )}
            </Typography>
          )}
          <Rating
            name="simple-controlled"
            value={model?.socialStatus?.averageStarRating ?? 0}
            onChange={(event, newValue) => {
              openReviewModal(newValue);
            }}
          />
        </div>
      </div>
      <div className="right-section">
        {(
          <Typography sx={{ fontSize: '1rem' }} color="text.secondary" gutterBottom textAlign={'left'}>
            Price Info: {model.pricingInfoToDisplay}
          </Typography>
        )}
        <MuiButton
          className="action-btn"
          onClick={() => headerAction(model && model.modelType === 'HostedModel' ? 'Try this out' : 'Visit Website')}
          color="success"
          variant="contained"
        >
          {model && model.modelType === 'HostedModel' ? 'Try this model' : 'Visit Website'}
        </MuiButton>
      </div>
    </div>
  );
};

export default HeaderSection;
